/**
 * Универсальный геттер для получения start параметра из Telegram WebApp
 * Должен вызываться самым первым, до монтирования роутера,
 * чтобы SPA/HashRouter не потерял query параметры
 */
export function getStartParam(): string | null {
  console.log('🔍 Universal getStartParam: checking all possible sources')
  
  // 1) официальный способ — query-параметр
  const url = new URL(window.location.href)
  let p = url.searchParams.get('tgWebAppStartParam') || url.searchParams.get('startapp')
  console.log('🔍 Universal getStartParam: from URL query params:', p)
  if (p) return p

  // 2) launch params прямо из Telegram
  const twa = (window as any).Telegram?.WebApp
  p = twa?.initParams?.tgWebAppStartParam
  console.log('🔍 Universal getStartParam: from initParams.tgWebAppStartParam:', p)
  if (p) return p

  // 3) старые свойства клиента
  p = twa?.startParam || twa?.start_param
  console.log('🔍 Universal getStartParam: from startParam/start_param:', p)
  if (p) return p

  // 4) дубль в initDataUnsafe
  p = twa?.initDataUnsafe?.start_param ?? null
  console.log('🔍 Universal getStartParam: from initDataUnsafe.start_param:', p)
  if (p) return p

  // 5) крайний случай: кто-то положил в hash
  const hashParams = new URLSearchParams(window.location.hash.slice(1))
  p = hashParams.get('tgWebAppStartParam') || hashParams.get('startapp') || null
  console.log('🔍 Universal getStartParam: from hash params:', p)
  
  console.log('🔍 Universal getStartParam: final result:', p)
  return p
}
